/**
 * Color constants mirroring tailwind.config.js (theme.extend.colors).
 *
 * Only for APIs that need a raw hex value — Google Maps overlays, canvas,
 * chart libraries. Everything rendered as DOM uses the Tailwind classes.
 *
 * Keep in sync by hand: a CRA/Craco build cannot import the Tailwind config here.
 */

export const colors = {
	primary: {
		100: '#f4f3ff',
		200: '#e4e0ff',
		300: '#afa3ff',
		400: '#9584ff',
		500: '#7b66ff',
		600: '#6252cc',
		700: '#4a3d99',
	},
	accent: '#dcd443',
	success: {
		200: '#EaFFF4',
		500: '#61E9A7',
		700: '#43966E',
	},
	caution: {
		200: '#FFEFE4',
		500: '#ffa566',
		700: '#dd630e',
	},
	warning: {
		200: '#FFE6E2',
		500: '#F16856',
		700: '#C00F0C',
	},
	bgBase: {
		200: '#f9fbfd',
		300: '#f4f8fc',
		400: '#eef4fa',
		500: '#e4eef8',
		600: '#9cb4cc',
		700: '#7995B2',
		800: '#537497',
	},
	text: '#060814',
	white: '#fff',
};
